import {
  List,
  Datagrid,
  NumberField,
  FunctionField,
  TextInput,
  SelectInput,
} from "react-admin";
import { StatusChip } from "../../../../components/StatusChip";
import { CopyableField, DateTimeField } from "../../../../shared/fields";

const statuses = [
  "INITIALIZED",
  "ACTIVE",
  "REJECTED",
  "SHOULD_CASHOUT",
  "CASHED_OUT",
  "LOST",
  "SHOULD_ROLLBACK",
  "ROLLED_BACK",
  "SHOULD_CANCEL",
  "CANCELLED",
];

const filters = [
  <TextInput key="roundId" source="roundId" label="Round ID" alwaysOn />,
  <TextInput key="userId" source="userId" label="User ID" alwaysOn />,
  <SelectInput
    key="status"
    source="status"
    choices={statuses.map((s) => ({ id: s, name: s }))}
    alwaysOn
  />,
];

export const BetList = () => (
  <List
    filters={filters}
    sort={{ field: "createdAt", order: "DESC" }}
    perPage={25}
  >
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <CopyableField source="betId" label="Bet ID" sortable={false} />
      <CopyableField source="roundId" label="Round ID" sortable={false} />
      <CopyableField source="userId" label="User ID" sortable={false} />
      <FunctionField
        label="Status"
        render={(r: { status?: string }) => <StatusChip value={r?.status} />}
      />
      <NumberField
        source="betAmount"
        label="Bet"
        options={{ minimumFractionDigits: 2 }}
      />
      <NumberField
        source="payoutMultiplier"
        label="Payout x"
        options={{ minimumFractionDigits: 2 }}
      />
      <NumberField
        source="payoutAmount"
        label="Payout"
        options={{ minimumFractionDigits: 2 }}
      />
      <DateTimeField source="createdAt" label="Created" />
    </Datagrid>
  </List>
);
